/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useRef } from 'react'
import {
  useSocketMessages,
  useHistory,
  useNotification,
  createSocket,
  addMouseFlow,
} from '@orbital/games-frontend-library'

import Holdem from './holdem/Holdem'
import {
  defaultGameInfo,
  defaultStateRound,
  defaultSeeds,
} from './lib/defaultValues.js'

import { helperReceiveSettings } from './settings/receiveSettings'
import { MessagesList } from './lib/hold_msg'
import { useHoldemSocketMessages } from './lib/holdemSocketMessages'
import { useSettings } from './settings/useSettings'

import { defaultStakes, defaultAudio } from './lib/defaultValues'

import { setAudios, setStakes } from './settings/useSettings'

function App() {
  const [gameInfo, setgameInfo] = useState(defaultGameInfo)
  const WS_URL = '{{SERVER_WS_URL}}'
  const name = 'orbital.casinoholdem'
  const wsbridge = 'wsbridge/v1/game'
  // const environment = "test";
  // const balanceUpdateOn = "now";
  const [stateRound, setStateRound] = useState(defaultStateRound)
  const [history, addInHistory] = useHistory(gameInfo.user_id)
  const [seeds, setSeeds] = useState(defaultSeeds)
  const [betReply, setBetReply] = useState({})

  const [notification, handleNotification, notificationfadeOut] =
    useNotification()

  const [errorCode, setErrorCode] = useState<number>(0)
  const [isError, setIsError] = useState<boolean>(false)

  const [errorText, seterrorText] = useState<string | false>(false)
  const handleErrorText = (text: string) =>
    seterrorText(errorText => (errorText ? errorText : text))

  const [stakesForSocket, setStakesForSocket] = useState(defaultStakes)
  const [audioForSocket, setSocketaudio] = useState(defaultAudio)

  useEffect(() => {
    switch (errorCode) {
      case 3:
      case 4:
      case 6:
      case 11:
      case 16:
      case 17:
      case 115:
        setIsError(true)
        setTimeout(() => {
          setErrorCode(0)
        }, 1000)
        break
      default:
        setIsError(false)
        break
    }
  }, [errorCode])

  const receiveSettings = (obj: string) =>
    helperReceiveSettings(obj, setStakesForSocket, setSocketaudio)

  const socket = useRef<any>(null)
  const [setStatus, receiveMessage, sendSocketMessage, sender] =
    useSocketMessages({
      socket,
      MessagesList,
      setStateRound,
      setgameInfo,
      addInHistory,
      setSeeds,
      handleErrorText,
      receiveSettings,
      setBetReply,
      handleNotification,
      setErrorCode,
    })
  useEffect(() => {
    if (!socket.current)
      createSocket(socket, receiveMessage, setStatus, WS_URL, name, wsbridge)
  }, [socket, receiveMessage, setStatus])

  const holdemSocketMessages = useHoldemSocketMessages(sendSocketMessage)

  const settingsFromSocket = useSettings(sendSocketMessage)

  useEffect(() => {
    setAudios(audioForSocket)
  }, [audioForSocket])

  useEffect(() => {
    setStakes(stakesForSocket.ante, stakesForSocket.AAbonus)
  }, [stakesForSocket])

  useEffect(() => {
    console.log('%cV2.0.2 DG', 'background: green; font-size: 16px')
  }, [])

  useEffect(() => addMouseFlow(), [])
  return (
    <Holdem
      gameInfo={gameInfo}
      stateRound={stateRound}
      history={history}
      betReply={betReply}
      seeds={seeds}
      seedRequest={sender.seedRequest}
      newSeedRequest={sender.newSeedRequest}
      requestBetReply={sender.requestBetReply}
      handleDeal={holdemSocketMessages.handleDeal}
      handleRaise={holdemSocketMessages.handleRaise}
      handleFold={holdemSocketMessages.handleFold}
      errorText={errorText}
      stakesForSocket={stakesForSocket}
      isError={isError}
      notification={notification}
      notificationfadeOut={notificationfadeOut}
      handleNotification={handleNotification}
    />
  )
}
export default App
